// Final boundary of the first handoff: Kanemori and its service wing.
// Keep the existing cyan landmark sign, lobby and gameplay-facing identity.
import type {HdBuilding} from '../../common/src/data';
import {type G,K,HT,px,frame,disc} from './hd-kit';
import {panel,fan,pipe,window} from './hd-hachi-study';
export function paintKanemoriLandmark(g:G,b:HdBuilding,x:number,y:number){
 if(b.id!=='kanemori'&&b.id!=='nw-wing')return;
 const w=b.w*HT,h=b.h*HT,rh=(b.h-b.face)*HT;
 g.save();g.beginPath();g.rect(x,y,w,rh);g.clip();
 // Retain all original facade pixels and lights. Roof rails stay within solid tiles.
 pipe(g,x+w-13,y+18,rh-35);
 for(const yy of [y+15,y+rh-17]){px(g,x+14,yy,w-29,2,K.metalHi);for(let j=17;j<w-17;j+=12)px(g,x+j,yy-5,2,9,K.metalLo);}
 if(b.id==='kanemori'){
  panel(g,x+20,y+97,w-44,54,K.concreteLo);fan(g,x+28,y+106);fan(g,x+64,y+106);
  window(g,x+27,y+212,w-57,47,K.glassLo);for(let j=1;j<3;j++)px(g,x+29,y+212+j*15,w-61,2,K.metalHi);
  px(g,x+25,y+275,w-53,9,K.metalLo);px(g,x+27,y+277,w-57,2,K.metalHi);
 }else{
  panel(g,x+20,y+130,w-43,72,K.metalLo);for(let j=6;j<65;j+=7)px(g,x+25,y+130+j,w-53,2,K.metalHi);
  panel(g,x+25,y+279,w-53,59,K.concreteLo);window(g,x+32,y+288,w-67,36,K.glassLo);
  // Drain collar and low equipment plinth, not a new walkable stair/ramp.
  disc(g,x+30,y+352,8,4,K.metalHi);disc(g,x+30,y+352,4,2,K.ink);
 }
 frame(g,x+3,y+3,w-6,rh-6,K.metalLo);g.restore();
}
